import { AwsRum, AwsRumConfig } from "aws-rum-web";

import { config } from "config";

export const useInjectCloudwatchRum = () => {
  if (
    window.location.hostname?.includes("dev.moodys.com") &&
    !("Cypress" in window)
  ) {
    try {
      const rumConfig: AwsRumConfig = {
        sessionSampleRate: 1,
        identityPoolId: config.CLOUDWATCH_RUM_POOL_ID,
        endpoint: config.CLOUDWATCH_RUM_ENDPOINT,
        telemetries: ["performance", "errors", "http"],
        allowCookies: true,
        enableXRay: false,
      };

      const APPLICATION_ID = config.CLOUDWATCH_RUM_ID;
      const APPLICATION_VERSION = "1.0.0";
      const APPLICATION_REGION = config.AWS_REGION;

      new AwsRum(
        APPLICATION_ID,
        APPLICATION_VERSION,
        APPLICATION_REGION,
        rumConfig
      );
    } catch (error) {
      // Ignore errors thrown during CloudWatch RUM web client initialization
    }
  }
};
